<template>
  <v-dialog v-model="sessionReplayStore.isStartDialogOpen" :persistent="sessionReplayStore.isStopping" max-width="560">
    <v-card>
      <v-card-title class="c-modal__header">{{ $t("sessionReplay.start") }}</v-card-title>
      <v-card-text class="text-body-2">
        <div class="s-sentryReplayStartDialog__instructions" v-html="$t('sessionReplay.startedInstructions')" />
        <v-alert v-if="sessionReplayStore.error" type="error" class="mt-4">{{ $t(`sessionReplay.${sessionReplayStore.error}`) }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <k-button :disabled="sessionReplayStore.isStopping" @click="sessionReplayStore.isStartDialogOpen = false">{{ $t("global.cancel") }}</k-button>
        <k-button primary :disabled="sessionReplayStore.isStopping" @click="sessionReplayStore.start">{{ $t("sessionReplay.startRecording") }}</k-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useSessionReplayStore } from "@/store/sessionReplay"

const sessionReplayStore = useSessionReplayStore()
</script>

<style scoped lang="scss">
.s-sentryReplayStartDialog__instructions :deep(p + p) {
  margin-top: 16px;
}
</style>
